import { createStore, applyMiddleware, combineReducers, compose } from "redux";
import thunk from "redux-thunk";
import applicationReducer from "./application/applicationReducer";

const rootReducer = combineReducers({
    applicationState: applicationReducer
});

export type RootState = ReturnType<typeof rootReducer>;

//const enhancer = compose(applyMiddleware(thunk), (window as any).__REDUX_DEVTOOLS_EXTENSION__ && (window as any).__REDUX_DEVTOOLS_EXTENSION__());

const store = createStore(rootReducer, applyMiddleware(thunk));
export default store;